import React from "react";
import { withTranslation } from "react-i18next";
import { Grid, InputAdornment, Typography } from "@mui/material";
import PropTypes from "prop-types";

import InputFieldText from "Components/Common/InputFieldText";
import FireSafetyCertificateApproval from "./FireSafetyCertificateApproval";
import AddressForFireSafety from "./AddressForFireSafety";
import BuildingInformation from "./BuildingInformation";
import BuildingAuthorityDetails from "./BuildingAuthorityDetails";
import FloorWiseTenantDetails from "./FloorWiseTenantDetails";

import { onlyNumberKeys } from "utils";
import FireSafetyCertificateRenewal from "./FireSafetyCertificateRenewal";

const GeneralBuildingInformation = ({ formik, t, floorOptions }) => {
  return (
    <Grid container columnSpacing={1} rowSpacing={1}>
      {/* Building Authority Details */}
      <BuildingAuthorityDetails formik={formik} />

      {/* AddressForFireSafety Details  */}
      <AddressForFireSafety formik={formik} />

      {/* Fire Safety Certificate Approval*/}
      <FireSafetyCertificateApproval formik={formik} />

      {/* FACR */}
      <FireSafetyCertificateRenewal formik={formik} />
      
      {/* Building Information */}
      <BuildingInformation formik={formik} floorOptions={floorOptions} />

      <Grid item xs={12}>
        <Typography className="mb-3" lineHeight={1} variant="h6">
          {t(
            "Maximum width of clear motorable open space in the front and side of the building block"
          )}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <InputFieldText
          label={t("Front") + "*"}
          name="frontClearSpace"
          type="number"
          formik={formik}
          placeholder="Enter Front Area"
          InputProps={{
            endAdornment: <InputAdornment position="end">Mtrs</InputAdornment>,
            inputProps: {
              min: 0,
              onKeyDown: (e) => onlyNumberKeys(e, true),
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <InputFieldText
          label={t("Back") + "*"}
          name="backClearSpace"
          type="number"
          formik={formik}
          placeholder="Enter Back Area"
          InputProps={{
            endAdornment: <InputAdornment position="end">Mtrs</InputAdornment>,
            inputProps: {
              min: 0,
              onKeyDown: (e) => onlyNumberKeys(e, true),
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <InputFieldText
          label={t("Right") + "*"}
          name="rightClearSpace"
          type="number"
          formik={formik}
          placeholder="Enter Right Area"
          InputProps={{
            endAdornment: <InputAdornment position="end">Mtrs</InputAdornment>,
            inputProps: {
              min: 0,
              onKeyDown: (e) => onlyNumberKeys(e, true),
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <InputFieldText
          label={t("Left") + "*"}
          name="leftClearSpace"
          type="number"
          formik={formik}
          placeholder="Enter Left Area"
          InputProps={{
            endAdornment: <InputAdornment position="end">Mtrs</InputAdornment>,
            inputProps: {
              min: 0,
              onKeyDown: (e) => onlyNumberKeys(e, true),
            },
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <InputFieldText
          label={`${t("Mention Obstructions")} (${t("if any")})`}
          name="mentionObstructions"
          formik={formik}
          placeholder="Enter Obstruction"
        />
      </Grid>

      {/* Floor Wise Tenant Details  */}
      <FloorWiseTenantDetails formik={formik} />
    </Grid>
  );
};

GeneralBuildingInformation.propTypes = {
  formik: PropTypes.object,
  t: PropTypes.func,
  floorOptions: PropTypes.array,
};

export default withTranslation()(GeneralBuildingInformation);
